import { motion } from 'motion/react';

export function LastUpdatedTagSkeleton() {
  return (
    <div className="flex justify-center">
      <div className="bg-white/10 rounded-full px-3 py-0.5">
        <motion.div
          className="h-[22px] w-[140px] bg-white/20 rounded"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
    </div>
  );
}
